/* ENTR0PY theme glue — UI only, NO generation engine.
 * The design algorithm runs SERVER-SIDE (Node CLI) and never ships to the
 * browser; the storefront only shows pre-rendered images. This file is data +
 * UI: the live NIST beacon line, the product variant selector, the batch
 * open/closed state. The verify lookup, the draw trace and the published PRNG
 * port were removed 2026-09-23 (law 4 amended; /pages/how-it-works replaced
 * /pages/verify and /pages/process).
 */
(function(){
"use strict";

/* ---- batch data, read from Shopify ----
 * Rendered by snippets/sw-batch-data.liquid out of collection and product
 * metafields. The theme carries NO batch data of its own: the hardcoded DROPS
 * constant that used to live here had one batch typed into it by hand and would
 * have needed editing for every release, and assets/sw-batches.js shipped a
 * frozen 66 kB copy that drifted from Shopify (three printed counts, one
 * screen). Everything is now sourced once, at publish time, into Shopify. */
var SW=(function(){
  var el=document.getElementById("sw-batch-data");
  if(!el)return null;
  try{return JSON.parse(el.textContent);}catch(e){return null;}
})();
window.SW_BATCH=SW;

/* qty steppers: delegated − / + handlers. Cart only now — the product page's
 * stepper is gone (one more control between the size and the button, on a
 * made-to-order garment whose story is "a few prints"; the cart still edits it).
 *
 * A change SUBMITS the cart form. "update" used to be a button the same size as
 * "checkout →" at the other end of the row, so the one screen with a single
 * obvious next action showed two identical-looking ones — and a shopper who
 * changed a quantity and pressed checkout silently checked out the old one. */
function submitCart(){
  var f=document.getElementById("cart-form");
  if(!f)return;
  /* requestSubmit so the form's own validation and the submit event still run;
   * older Safari has no requestSubmit, hence the fallback. */
  if(f.requestSubmit)f.requestSubmit();else f.submit();
}
document.addEventListener("click",function(e){
  var btn=e.target.closest(".qty-btn");if(!btn)return;
  var input=btn.parentElement.querySelector("input[type=number]");if(!input)return;
  var min=parseInt(input.min||"0",10);
  var v=(parseInt(input.value,10)||min)+parseInt(btn.dataset.step,10);
  input.value=Math.max(min,v);
  input.dispatchEvent(new Event("change",{bubbles:true}));});
/* 2026-10-07: a quantity change no longer reloads the page. Taps are gathered for 400 ms,
 * sent to /cart/update.js, and the cart section is re-rendered in place (Section Rendering
 * API); the header's count follows. Any failure falls back to submitting the form. */
var cartTimer=0,cartSeq=0;
/* 2026-10-08: only the newest request may repaint (a tap while one is in flight used to be
 * overwritten by the older response); the close state is repainted too; keyboard focus goes
 * back to the same − / + / field on the same line; and a polite live region outside the
 * replaced section reads out the new subtotal. */
function cartFocusKey(sec){
  var a=document.activeElement;if(!a||!sec.contains(a))return null;
  var rows=Array.prototype.slice.call(sec.querySelectorAll(".qty-stepper"));
  for(var i=0;i<rows.length;i++)if(rows[i].contains(a))
    return{row:i,sel:a.classList.contains("qty-btn")?'.qty-btn[data-step="'+a.dataset.step+'"]':"input.qty"};
  return null;
}
function cartAnnounce(text){
  var r=document.getElementById("cart-status");
  if(!r){r=document.createElement("p");r.id="cart-status";r.className="sr-only";r.setAttribute("aria-live","polite");document.body.appendChild(r);}
  r.textContent="";setTimeout(function(){r.textContent=text;},50);
}
function updateCart(){
  var f=document.getElementById("cart-form"),sec=f&&f.closest(".shopify-section");
  if(!f||!sec||!window.fetch){submitCart();return;}
  var seq=++cartSeq;
  var id=sec.id.replace(/^shopify-section-/,""),root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
  var updates=Array.prototype.map.call(f.querySelectorAll("input.qty"),function(i){return parseInt(i.value,10)||0;});
  fetch(root+"cart/update.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
    body:JSON.stringify({updates:updates,sections:[id],sections_url:location.pathname})})
  .then(function(r){if(!r.ok)throw r;return r.json();})
  .then(function(cart){
    if(seq!==cartSeq||cartTimer)return;  /* a newer change is queued or in flight */
    var html=cart.sections&&cart.sections[id];if(!html)throw 0;
    var doc=new DOMParser().parseFromString(html,"text/html"),fresh=doc.getElementById(sec.id)||doc.body.firstElementChild;
    if(!fresh)throw 0;
    var key=cartFocusKey(sec);
    sec.innerHTML=fresh.innerHTML;
    if(key){
      var row=sec.querySelectorAll(".qty-stepper")[key.row],el=row&&row.querySelector(key.sel);
      (el||sec.querySelector("#cart-checkout")||sec).focus({preventScroll:true});
    }
    document.querySelectorAll(".cartcount .zero").forEach(function(n){n.textContent=cart.item_count;});
    if(typeof paintCloseTimes==="function")paintCloseTimes();
    if(typeof paintState==="function")paintState();
    var tot=sec.querySelector(".tot .money");
    cartAnnounce(cart.item_count?("subtotal "+(tot?tot.textContent.trim():"")+", "+cart.item_count+(cart.item_count===1?" item":" items")):"your cart is empty");
  })
  .catch(function(){if(seq===cartSeq)submitCart();});
}
document.addEventListener("change",function(e){
  var input=e.target.closest("#cart-form .qty");if(!input)return;
  clearTimeout(cartTimer);cartTimer=setTimeout(function(){cartTimer=0;updateCart();},400);});

/* breadcrumb trail: copy the current URL to the clipboard. A quiet colour flip
 * is the only feedback — no toast, no layout shift. */
document.addEventListener("click",function(e){
  var btn=e.target.closest(".copylink");if(!btn)return;
  var url=window.location.href;
  if(!navigator.clipboard||!navigator.clipboard.writeText)return;
  navigator.clipboard.writeText(url).then(function(){
    btn.classList.add("copied");
    btn.setAttribute("aria-label","link copied");
    setTimeout(function(){
      btn.classList.remove("copied");
      btn.setAttribute("aria-label","copy link to this page");
    },1400);
  }).catch(function(){});});

/* Is this a URL we can put in an <img src>? Shopify CDN paths are protocol-
 * relative or absolute; anything else (notably a Liquid error string) is not. */
function isURL(u){return typeof u==="string"&&/^(https?:)?\/\//.test(u);}

/* product page: colour/size option selectors + dynamic variant image/price */
function mountProduct(){
  var dataEl=document.getElementById("variant-data");if(!dataEl)return;
  var variants;try{variants=JSON.parse(dataEl.textContent);}catch(e){return;}
  var sel=[];
  var main=document.getElementById("mainimg"),price=document.getElementById("price"),
      vsel=document.getElementById("variant-select"),addbtn=document.querySelector(".addbtn");
  /* apply() runs once at mount to sync price and availability. On that first run
   * it must NOT touch the image: Liquid deliberately renders the featured image
   * (the lifestyle shot) rather than the default variant's, and swapping to the
   * default variant's flat here would undo that on every page load. Only a real
   * user choice changes the frame. */
  var firstApply=true;
  function apply(){
    var v=variants.filter(function(x){return x.options.every(function(o,i){return o===sel[i];});})[0];
    /* an option nobody has chosen yet is not an unavailable combination — it is
       a choice still to make. The size row starts EMPTY (2026-09-08: S was
       preselected and a buyer could claim without seeing a measurement), so
       until it is chosen the button asks for it by name. */
    var missing=groups.filter(function(g){return sel[g.idx]==null;})[0];
    if(!v&&missing){
      /* a colour tap with the size still unchosen used to leave whichever image
         Liquid rendered first (often the lifestyle frame) on screen, because
         this branch returned before the image swap below ever ran. Match on
         only the options actually chosen and swap to that variant's image, so
         tapping a colour shows that colour immediately. */
      var byChosen=variants.filter(function(x){
        return x.options.every(function(o,i){return sel[i]==null||o===sel[i];});
      })[0];
      if(main&&!firstApply&&byChosen&&isURL(byChosen.image)){
        main.removeAttribute("srcset");main.src=byChosen.image;
      }
      if(addbtn){addbtn.disabled=true;addbtn.textContent="choose a "+missing.name+" →";}
      /* apply() otherwise overwrites whatever paintState() last set on the
         button (e.g. "expired — seed retired") with the "choose a…" prompt
         above and returns before paintState() runs again — so a retired
         design's button flipped back to inviting a purchase the moment a
         shopper tapped a colour or size. Re-running it here keeps the two in
         step on every path through apply(), not just the one that reaches a
         full, valid selection. */
      paintState();
      syncBuyBar();
      return;
    }
    /* an unmatched combination used to return here silently: nothing moved, the
       price stayed on the last valid variant and the hidden id still pointed at
       it, so the button offered to sell a combination that does not exist. Say
       so instead. */
    if(!v){
      if(addbtn){addbtn.disabled=true;addbtn.textContent="not printed in that combination";}
      paintState();
      syncBuyBar();
      return;
    }
    /* the <select> is the form's only `id` field and works with JS off; here it
       is simply kept in step with the button UI, so there is one value in one
       element rather than two that can disagree. */
    if(vsel)vsel.value=String(v.id);
    if(price)price.textContent=v.price;
    /* mainimg still carries the srcset/sizes Liquid rendered for the FIRST
       image — browsers pick from srcset over a plain .src assignment, so
       swapping .src alone silently did nothing visible the moment srcset had
       already resolved to a candidate. Dropping srcset makes .src authoritative
       again; same fix applied in show() below for gallery navigation.

       isURL() is the other half of the tee-off blank-plate bug. Liquid emitted
       `Liquid error (sections/sw-product line 186): invalid url input` into the
       variant JSON for every variant with no image of its own, and that string
       is truthy — so this ran on page load and set the main image's src to
       `/products/Liquid%20error…`, discarding the correct 1400px image Liquid
       had already rendered. The Liquid side now emits null; this refuses
       anything that is not a real URL, so a future publish bug degrades to
       "the image did not change" rather than "the product has no photo". */
    if(main&&!firstApply&&isURL(v.image)){main.removeAttribute("srcset");main.src=v.image;}
    /* a variant that has run out is SOLD OUT; "expired — seed retired" is the
       batch's state and is painted below from the close time */
    if(addbtn){addbtn.disabled=!v.available;addbtn.textContent=v.available?("buy — "+v.price+" →"):"unavailable";}
    /* a variant swap must not resurrect the buy button on a closed batch */
    paintState();
    syncBuyBar();
    paintColour();
  }
  /* the fallback select stays authoritative if it is used directly (JS on, but
     the buttons never clicked) */
  if(vsel)vsel.addEventListener("change",function(){
    var v=variants.filter(function(x){return String(x.id)===vsel.value;})[0];
    if(!v)return;
    sel=v.options.slice();
    document.querySelectorAll(".opts").forEach(function(g){
      var i=parseInt(g.dataset.opt,10)-1;
      g.querySelectorAll(".optbtn").forEach(function(b){
        var on=b.dataset.value===sel[i];
        b.classList.toggle("on",on);b.setAttribute("aria-pressed",on?"true":"false");
      });
    });
    apply();
  });
  var groups=[];
  document.querySelectorAll(".opts").forEach(function(group){
    var idx=parseInt(group.dataset.opt,10)-1;
    groups.push({idx:idx,name:group.dataset.name||"option",el:group});
    /* a group with no `.on` button stays unchosen — it no longer falls back to
       the first button, which is what silently made S the default */
    var on=group.querySelector(".optbtn.on");
    sel[idx]=on?on.dataset.value:null;
    group.querySelectorAll(".optbtn").forEach(function(btn){
      btn.addEventListener("click",function(){
        group.querySelectorAll(".optbtn").forEach(function(b){b.classList.remove("on");b.setAttribute("aria-pressed","false");});
        btn.classList.add("on");btn.setAttribute("aria-pressed","true");sel[idx]=btn.dataset.value;
        if(group.dataset.size)paintSizeHint(group,btn.dataset.value);
        apply();
      });
    });
    if(group.dataset.size&&on)paintSizeHint(group,on.dataset.value);
  });
  /* "check the guide" opens the fold and scrolls to it */
  var sgo=document.getElementById("size-guide-open"),sg=document.getElementById("size-guide");
  if(sgo&&sg)sgo.addEventListener("click",function(){
    sg.open=true;sg.scrollIntoView({behavior:"smooth",block:"nearest"});
  });
  /* the plate never shows as a bare box: the image fades in once decoded */
  if(main){
    /* already decoded (cached, or the preload won the race): show it at once,
       with no transition to wait on. Only an image still in flight fades in. */
    if(main.complete&&main.naturalWidth>0){main.classList.add("now","loaded");}
    else{
      var loaded=function(){main.classList.add("loaded");};
      main.addEventListener("load",loaded);main.addEventListener("error",loaded);
      /* and a floor: whatever happens, the plate is never blank for long */
      setTimeout(function(){main.classList.add("now","loaded");},2500);
    }
  }
  /* gallery: arrows, keyboard and a thumb state that actually tracks the frame.
   * Previously a thumb click only swapped the src, so aria-current stayed stuck
   * on whichever thumb Liquid rendered first and nothing told you where you were. */
  var thumbs=Array.prototype.slice.call(document.querySelectorAll(".thumb")),
      shots=thumbs.map(function(t){return t.dataset.full;}),at=0;
  function paintThumbs(){
    thumbs.forEach(function(t,n){
      t.setAttribute("aria-current",n===at?"true":"false");
      t.classList.toggle("on",n===at);
    });
    var c=document.getElementById("gal-count");
    if(c)c.textContent=(at+1)+" / "+shots.length;
  }
  function show(i){
    if(!shots.length)return;
    at=(i+shots.length)%shots.length;
    /* the actual "arrows don't switch images" bug: mainimg's srcset (rendered
       by Liquid for the first image only) outranks a plain .src assignment in
       every modern browser, so this silently kept displaying whichever srcset
       candidate had already resolved — .src changed, nothing visible did.
       Drop srcset once navigation starts driving the image instead of the
       initial responsive load. */
    if(main){main.removeAttribute("srcset");main.src=shots[at];}
    /* "print shown at true scale" was painted once by mountCandidate() and left
       under every frame — five of tee-off's six shots are model or flat-lay
       photos, so the claim was false on five of them, on the page that sells
       itself on not making false claims. It belongs to frame 0 only. */
    paintScaleLabel(at);
    paintThumbs();
    if(thumbs[at])thumbs[at].scrollIntoView({block:"nearest",inline:"nearest"});
  }
  thumbs.forEach(function(t,i){t.addEventListener("click",function(){show(i);});});
  document.querySelectorAll(".galnav").forEach(function(b){
    b.addEventListener("click",function(e){
      e.preventDefault();show(at+(b.dataset.dir==="next"?1:-1));
    });
  });
  /* arrow keys belong to the gallery only when the gallery has focus. This was
     bound to `document` and called preventDefault() on the whole page, so it
     stole ArrowLeft/Right from every horizontally scrollable region on the
     product page (.tablewrap, .trace.wide) and from anyone navigating by
     keyboard. The plate takes focus and handles its own keys. */
  var plate=document.querySelector("#sw-product .plate");
  if(shots.length>1&&plate){
    plate.setAttribute("tabindex","0");
    plate.setAttribute("role","group");
    plate.setAttribute("aria-label","product images — use arrow keys");
    /* 2026-09-27 (owner): ←/→ step the gallery anywhere on the product page, not only
       when the plate has focus — except where the keys already mean something: typing
       in a field, a focused control that uses arrows, or a horizontally scrollable
       region (the size table). Modifier keys pass through. */
    document.addEventListener("keydown",function(e){
      if(e.key!=="ArrowRight"&&e.key!=="ArrowLeft")return;
      if(e.altKey||e.ctrlKey||e.metaKey||e.shiftKey||e.defaultPrevented)return;
      var t=e.target;
      if(t&&(t.isContentEditable||/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)))return;
      if(t&&t.closest&&t.closest(".tscroll,.tablewrap,[role=slider],[role=tablist]"))return;
      e.preventDefault();show(at+(e.key==="ArrowRight"?1:-1));
    });
    /* swipe on touch: a mostly-horizontal drag of 40px or more steps the gallery;
       vertical drags stay page scrolls. */
    var sx=0,sy=0,tracking=false;
    plate.addEventListener("touchstart",function(e){
      if(e.touches.length!==1)return;
      sx=e.touches[0].clientX;sy=e.touches[0].clientY;tracking=true;
    },{passive:true});
    plate.addEventListener("touchend",function(e){
      if(!tracking)return;tracking=false;
      var t=e.changedTouches[0],dx=t.clientX-sx,dy=t.clientY-sy;
      if(Math.abs(dx)>=40&&Math.abs(dx)>Math.abs(dy)*1.3)show(at+(dx<0?1:-1));
    },{passive:true});
  }
  if(shots.length)paintThumbs();  /* state only — Liquid owns the initial src */
  paintScaleLabel(0);
  apply();
  firstApply=false;
  /* show(i) only ever swapped main.src, so every thumb/arrow click paid a fresh
     network fetch for a 1400px image the browser had never seen — the "gallery
     feels slow" complaint. Warm the cache for every OTHER shot once the visible
     image has had a chance to load, so a later click just repaints from cache
     instead of re-fetching. Idle-scheduled so it never competes with the LCP
     image itself. */
  if(shots.length>1){
    var preload=function(){
      shots.forEach(function(src,i){
        if(i===at)return;
        var pre=new Image();
        pre.src=src;
      });
    };
    if(window.requestIdleCallback)requestIdleCallback(preload);
    else setTimeout(preload,200);
  }
  /* hover-zoom: cursor position drives transform-origin, .plate scales #mainimg
   * and clips it (`.plate{overflow:hidden}` already exists for this). Gated on
   * real hover so touch never attaches a listener — no stuck-zoomed state from
   * a tap, no pinch-zoom to fight with. */
  var plateZoom=document.querySelector("#sw-product .plate");
  if(plateZoom&&main&&window.matchMedia&&matchMedia("(hover:hover)").matches){
    plateZoom.addEventListener("mousemove",function(e){
      var r=plateZoom.getBoundingClientRect();
      var x=((e.clientX-r.left)/r.width)*100,y=((e.clientY-r.top)/r.height)*100;
      main.style.transformOrigin=x+"% "+y+"%";
    });
    /* 2026-10-07: click to zoom, not hover. Crossing the plate with the cursor zoomed it to
       2.2×, so the whole garment vanished on the way to the size buttons. */
    plateZoom.style.cursor="zoom-in";
    plateZoom.addEventListener("click",function(e){
      if(e.target.closest("a,button"))return;
      var on=plateZoom.classList.toggle("zoom");
      plateZoom.style.cursor=on?"zoom-out":"zoom-in";
    });
    plateZoom.addEventListener("mouseleave",function(){plateZoom.classList.remove("zoom");plateZoom.style.cursor="zoom-in";});
  }
}

/* The chosen size's flat measurement, read out of the size-guide setting
 * ("… S 46cm · M 51cm · L 56cm …") and printed under the size row — so the one
 * measurement that decides the fit is seen at the moment the size is chosen,
 * not behind a fold. The no-exchange fact sits on the same line: it governs
 * this choice, so it lives next to it rather than in the footer. */
function paintSizeHint(group,value){
  var hint=document.getElementById("size-hint");if(!hint)return;
  var guide=group.dataset.sizeguide||"";
  var re=new RegExp("(^|[^A-Za-z0-9])"+value.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")+"\\s*[:·]?\\s*(\\d+(?:[.,]\\d+)?)\\s*cm","i");
  var m=re.exec(guide);
  var open=document.getElementById("size-guide-open");
  var link=open?' <button type="button" class="linkish" id="size-guide-open">check the guide</button>':"";
  /* "a tee you like" on a hoodie page told a buyer to go measure the wrong
     garment — this hint is shared across every product that has a size. */
  hint.innerHTML=(m?("<b>"+value+" · "+m[2]+" cm</b> — compare with one you own, laid flat. "):"")+
    link;
  var sgo=document.getElementById("size-guide-open"),sg=document.getElementById("size-guide");
  if(sgo&&sg)sgo.addEventListener("click",function(){sg.open=true;sg.scrollIntoView({behavior:"smooth",block:"nearest"});});
}

/* Delivery (2026-10-08, owner): one honest figure, rendered by Liquid: "95% of orders
 * arrive within 15 days of dispatch". No date computed from today: that would need the
 * printing days, which the site never states. */

/* ---- the console shell: rail provenance + the live open/closed state ----
 * Painted on every page from SW_BATCH. The close date comes from the batch's
 * own archive record, falling back to the homepage section setting. */
function fmtUTC(iso){
  var d=new Date(iso);if(isNaN(d))return"";
  var p=function(n){return String(n).padStart(2,"0");};
  return d.getUTCFullYear()+"-"+p(d.getUTCMonth()+1)+"-"+p(d.getUTCDate())+
    " · "+p(d.getUTCHours())+":"+p(d.getUTCMinutes())+" UTC";
}
/* date-only, in UTC. Slicing the raw ISO instead is timezone-naive: the close
 * metafield arrives with a store-local offset, so `slice(0,10)` on
 * 2026-07-28T00:59+01:00 printed the 28th while the bar correctly said
 * 2026-07-27 23:59 UTC — the same instant, two dates, on one screen. */
function fmtUTCDate(iso){
  var d=new Date(iso);if(isNaN(d))return"";
  var p=function(n){return String(n).padStart(2,"0");};
  return d.getUTCFullYear()+"-"+p(d.getUTCMonth()+1)+"-"+p(d.getUTCDate());
}
/* the `#sw-home` dataset override is gone with mountHome(): no section has
   rendered that element since the landing page became `#sw-landing`, so the
   first branch could never fire. The batch's own metafield is the answer. */
function batchCloses(B){
  if(B.closes)return B.closes;
  var a=(B.archive||[]).filter(function(x){return x.batch===B.batch&&x.closes;})[0];
  return a?a.closes:null;
}
/* ONE derived close state, propagated to everything that claims one. Before this
 * the top bar could read EXPIRED while the band said "claimable while the batch is
 * open", the rail dot kept beating and the CTA still took money. */
function batchState(B){
  var iso=batchCloses(B);
  if(!iso)return{iso:null,expired:false,ms:0};
  /* an UNPARSEABLE close time is not a close time. Only the empty case was
     guarded, so a metafield serialised as `2026-07-28 00:59:00 +0100` (Ruby's
     Time#to_s, which Safari refuses) produced NaN: `expired` came out false, the
     top bar printed "NaN:NaN:NaN", and a batch that had actually closed went on
     taking money. Same rule as a missing close time — we do not retire a seed
     because a date failed to parse — but the countdown must not render. */
  var d=new Date(iso);
  if(isNaN(d))return{iso:null,expired:false,ms:0};
  return{iso:iso,ms:d-Date.now(),expired:(d-Date.now())<=0};
}
var URGENT=1.728e8; /* 48h: inside it the page re-checks every second, so the buy button
  locks at the close itself. Nothing visible counts down (brand/BRAND.md §3, 2026-10-04). */
function paintState(){
  var B=window.SW_BATCH;if(!B)return;
  var st=batchState(B),el=document.getElementById("stage-rt");

  /* the rail's heartbeat is a liveness claim — it must stop when the batch does */

  if(el&&!st.iso)el.textContent="";
  else if(el&&!st.expired){
    /* 2026-10-04 (brand/BRAND.md §3): no countdown. The close is a date, stated as a fact. */
    el.innerHTML='<span class="state"><span class="dot"></span>open</span>'+
      '<span class="when">until '+fmtUTC(st.iso)+"</span>";
  }else if(el){
    /* expired: the useful fact is no longer the close time, it is the next draw.
       Read from the batch's own next_opens_at metafield — it used to come off a
       `#sw-home` data attribute that no section rendered. */
    /* 2026-10-07 (BRAND.md §3, no countdowns): the next opening as a date, not "next in Nd"
       or "next batch imminent"; nothing once that date has passed. */
    var nextIso=B.nextOpens||null,nx="";
    if(nextIso&&new Date(nextIso)>Date.now())nx='<span class="left">next batch '+fmtOpens(nextIso)+"</span>";
    el.innerHTML='<span class="state off">closed</span>'+nx+
      '<span class="when">closed '+fmtUTC(st.iso)+"</span>";
  }

  /* the `#band-state` branch is deleted: no section has rendered that element
     since the batch page dropped its band, so it painted nothing. */

  /* the claim button carries the deadline; when expired it stops taking money */
  var add=document.querySelector(".addbtn");
  if(add&&st.expired){add.disabled=true;add.textContent="closed — seed retired";}
  var scar=document.getElementById("p-scarcity");
  if(scar&&st.iso)scar.textContent=st.expired?"batch closed — this seed is retired"
    :("open until "+fmtUTC(st.iso));
  /* a page cached before the close still carries the open-batch lines (the Liquid
     expiry uses the render time): once closed, drop "printed to order…" and the
     delivery dates, and show what to do next instead. */
  if(st.expired){
    var on=document.getElementById("p-open-note");if(on)on.hidden=true;
    document.querySelectorAll(".eta[data-days]").forEach(function(e){e.hidden=true;});
    var cn=document.getElementById("p-closed-note");if(cn)cn.hidden=false;
    var su=document.getElementById("p-signup");if(su)su.hidden=false;
    var sp=document.getElementById("sw-product");if(sp)sp.classList.add("expired");
  }

  /* the big last-48-hours countdown block was removed 2026-09-23 (too loud); the
     "closes in" line beside the buy button and the close dates carry the deadline. */

  /* and the checkout, one page later — a closed batch must not take money there
   * either. Shopify still holds the line items; we stop the submit. */
  var co=document.getElementById("cart-checkout"),cs=document.getElementById("cart-state");
  if(co&&st.iso&&st.expired){co.disabled=true;co.textContent="batch closed";}
  if(cs&&st.iso)cs.textContent=st.expired
    ?"This batch closed "+fmtUTCDate(st.iso)+" — its seed is retired and nothing "+
     "in it can be bought now."
    :("open until "+fmtUTC(st.iso));
  if(document.getElementById("buybar-t"))syncBuyBar();
  return st;
}
/* Close times, formatted in UTC from epoch seconds.
 *
 * Liquid's `date` filter renders in the SHOP's timezone (Europe/London), so a
 * template that wrote `{{ closes_at | date: '%H:%M' }} UTC` printed 23:20 during
 * BST for the instant this function correctly calls 22:20 UTC — one deadline,
 * two times, on one screen. Liquid cannot convert timezones, so it emits epoch
 * seconds in `data-closes` and the formatting happens here, next to every other
 * UTC rendering on the site.
 *
 * `data-closes-short` asks for a date only (the archive list, where the time of
 * day is noise). */
/* "Tue 30 Sep 2026, 21:00 UTC" — the next-batch date, formatted in UTC from epoch
 * seconds in [data-opens] (same reason as data-closes: Liquid can't convert tz). */
function fmtOpens(iso){
  var d=new Date(iso);if(isNaN(d))return"";
  var p=function(n){return String(n).padStart(2,"0");};
  var D=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],M=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  return D[d.getUTCDay()]+" "+d.getUTCDate()+" "+M[d.getUTCMonth()]+" "+d.getUTCFullYear()+", "+
    p(d.getUTCHours())+":"+p(d.getUTCMinutes())+" UTC";
}
/* "in 7 days" / "in 5 hours" beside the next-batch date. Days are UTC calendar days, so the
 * count agrees with the date beside it. At the minute itself (2026-10-07) a page loaded earlier
 * would have said "opening now" with nowhere to go: it becomes a link to the shop instead, and
 * the check repeats every 30 s while such a line is on screen. */
function paintUntil(){
  var live=false;
  document.querySelectorAll("[data-until]").forEach(function(el){
    var at=parseInt(el.dataset.until,10)*1000,ms=at-Date.now();if(isNaN(ms))return;
    /* the "· " separator is CSS (.nextin::before), so a phone layout can drop it */
    if(ms<=0){
      var a=document.createElement("a");a.className="btn sm primary";
      a.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||"/")+"collections";
      /* verb-first (COPYWRITING §5), named after the teaser's batch when there is one */
      var nm=el.closest(".nextcta")&&el.closest(".nextcta").querySelector(".nextname");
      a.textContent="shop "+(nm?nm.textContent.trim().toLowerCase()+" ":"")+"→";
      var big=el.closest(".nextbig");
      if(big){big.replaceWith(a);}else{el.replaceWith(a);}
      return;
    }
    live=true;
    var day=function(t){var d=new Date(t);return Date.UTC(d.getUTCFullYear(),d.getUTCMonth(),d.getUTCDate());};
    /* under a day: hours ("in 1 day" at 23:30 with 9.5 h left read wrong), and under an hour
       "in under an hour" (it said "in 1 hours"). Otherwise UTC calendar days. */
    var d=Math.round((day(at)-day(Date.now()))/8.64e7),h=Math.floor(ms/3.6e6);
    el.textContent=ms<3.6e6?"in under an hour":ms<8.64e7?("in "+h+(h===1?" hour":" hours")):("in "+d+(d===1?" day":" days"));
  });
  if(live&&!paintUntil.t)paintUntil.t=setInterval(paintUntil,30000);
  if(!live&&paintUntil.t){clearInterval(paintUntil.t);paintUntil.t=0;}
}
function paintCloseTimes(){
  document.querySelectorAll("[data-opens]").forEach(function(el){
    var secs=parseInt(el.dataset.opens,10);
    if(!isNaN(secs))el.textContent=fmtOpens(new Date(secs*1000).toISOString());
  });
  paintUntil();
  var now=Date.now();
  document.querySelectorAll("[data-closes]").forEach(function(el){
    var secs=parseInt(el.dataset.closes,10);
    if(isNaN(secs))return;
    var d=new Date(secs*1000),past=d.getTime()<=now;
    var iso=d.toISOString();
    if(el.hasAttribute("data-closes-short")){
      el.textContent=(past?"closed ":"closes ")+fmtUTCDate(iso);
    }else{
      el.textContent=(past?"closed ":"closes ")+fmtUTC(iso);
    }
  });
}

function mountShell(){
  var B=window.SW_BATCH;if(!B)return;
  var $=function(id){return document.getElementById(id);};
  /* the provenance card that lived here went with /collections/NN (2026-09-23). */
  /* The crumb is Liquid's, and only Liquid's.
   *
   * This used to build a label from the batch NUMBER, zero-padded to two digits,
   * so "Batch 0191" appeared as "batch #191"; then it filled any empty crumb
   * with the batch name, which put a batch on the home page — a page that shows
   * no batch. Liquid prints `collection.title` where a batch is the subject and
   * nothing where it is not, which is the whole answer. */
  /* self-scheduling so the cadence follows the deadline: 1 Hz inside the last
   * 48h (the countdown is a readout, and a static one is a screenshot), 1/min
   * otherwise. Re-evaluated each tick so it speeds up on its own. */
  (function tick(){
    var st=paintState();
    setTimeout(tick,(st&&!st.expired&&st.ms>0&&st.ms<URGENT)?1000:60000);
  })();
}

/* mountHome() is DELETED (2026-08-08). It painted `#ct-pulse` and `#ct-printed`
 * inside `#sw-home` — three ids that no section has rendered since the landing
 * became `#sw-landing`, so it returned at its first guard on every page load.
 * The rebuilt landing renders those figures from Liquid instead, which is the
 * right place for them: it is the page most likely to take a cold spike, and a
 * figure painted after load is a figure that arrives with layout shift. */

function esc(x){return String(x==null?"":x).replace(/[&<>"]/g,function(ch){
  return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[ch];});}

/* the kicker under the title: design number, family, and the garment's colour
 * (DCM-64, 2026-11-01). It used to print the drawn palette's name ("navy" on a
 * black tee); the colour here is the blank the buyer is choosing: the selected
 * Color option, with a swatch from custom.garment_hex. paintColour() keeps it
 * in step with the variant. The per-design draw trace that used to be painted
 * here was retired 2026-09-23 (law 4) — it proved two modulo operations while
 * the artwork step stays private. */
function mountCandidate(){
  var B=window.SW_BATCH,root=document.getElementById("sw-product");
  if(!B||!root)return;
  var sub=parseInt(root.dataset.sub,10);
  var c=(B.printed||[]).filter(function(x){return x.sub===sub;})[0];
  var sb=document.getElementById("p-sub");
  if(c&&sb){
    sb.innerHTML="design "+String(c.candidate).padStart(2,"0")+" · "+esc(c.family)+
      '<span id="p-colour"></span>';
    paintColour();
  }
}
function paintColour(){
  var out=document.getElementById("p-colour"),root=document.getElementById("sw-product");
  if(!out||!root)return;
  var g=document.querySelector('.opts[data-name="garment colour"]');
  var on=g&&g.querySelector(".optbtn.on");
  if(!on){out.innerHTML="";return;}
  var hex=root.dataset.garmenthex;
  out.innerHTML=" · "+(hex?'<i class="swatch" aria-hidden="true" style="background:'+esc(hex)+'"></i>':"")+
    esc(on.dataset.value.toLowerCase());
}

/* The "print shown at true scale" caption.
 *
 * It was painted once by mountCandidate() and left under every frame in the
 * gallery. Five of tee-off's six images are model or flat-lay photos, so the
 * claim was false on five of them — on the page that sells itself on not making
 * false claims.
 *
 * Tying it to frame 0 is not enough: frame 0 is a garment mockup too. The claim
 * is only true of the flat print render, and only the pipeline knows which image
 * that is. So it comes from a metafield (`entropy.print_frame`, a 0-based image
 * index) and is shown on that frame alone. With the metafield unset — which is
 * every product published so far — the caption never appears. A missing caption
 * costs nothing; a false one costs the only thing this brand sells. */
function paintScaleLabel(at){
  var lab=document.getElementById("p-plabel");
  if(!lab)return;
  var root=document.getElementById("sw-product");
  var raw=root?root.dataset.printframe:"";
  var frame=(raw==null||raw==="")?NaN:parseInt(raw,10);
  lab.textContent=(!isNaN(frame)&&at===frame)?"print shown at true scale":"";
}

/* The sticky buy bar (mobile). The real button is the one inside the form; this
 * mirrors its label and disabled state and forwards the click, so there is one
 * control and one source of truth — a second <form> would be a second thing that
 * can disagree about what is being bought. */
function syncBuyBar(){
  var bar=document.getElementById("buybar"),btn=document.getElementById("buybar-btn"),
      real=document.querySelector(".addbtn");
  if(!bar||!btn||!real)return;
  /* a retired design's real button correctly says "expired — seed retired",
     but mirroring that verbatim into the sticky bar would repeat a dead end
     instead of offering the one thing left to do. Left as its own label. */
  if(bar.dataset.expired==="true"){
    btn.disabled=false;
    btn.textContent="notify me →";
  }else{
    /* 2026-10-07: with no size chosen the real button is disabled ("choose a size →"), and
       the bar copied that, a greyed button that did nothing on a phone. It stays tappable
       and takes the visitor to the sizes instead (mountStickyBuy). */
    var needsSize=real.disabled&&document.querySelector(".opts[data-size]")&&!document.querySelector(".opts[data-size] .optbtn.on");
    btn.disabled=real.disabled&&!needsSize;
    btn.textContent=real.textContent.trim();
  }
  /* the topbar's state row is hidden below 60rem, so the countdown rides here */
  var t=document.getElementById("buybar-t"),B=window.SW_BATCH;
  if(t&&B){
    var st=batchState(B);
    /* 2026-10-04: no countdown here either (brand/BRAND.md §3) — just the title */
    t.textContent=t.dataset.title||"";
  }
}
function mountStickyBuy(){
  var bar=document.getElementById("buybar"),btn=document.getElementById("buybar-btn"),
      real=document.querySelector(".addbtn");
  if(!bar||!btn||!real)return;
  btn.addEventListener("click",function(){
    if(bar.dataset.expired==="true"){
      var su=document.querySelector(".signup");
      if(su)su.scrollIntoView({behavior:"smooth",block:"center"});
    }else if(real.disabled){
      var sz=document.querySelector(".opts[data-size]");
      if(sz){sz.scrollIntoView({behavior:"smooth",block:"center"});var b=sz.querySelector(".optbtn");if(b)b.focus({preventScroll:true});}
    }else{
      real.click();
    }
  });
  syncBuyBar();
  /* shown only once the real button has scrolled out of view. IntersectionObserver
   * rather than a scroll handler: no work on the main thread while scrolling. */
  if(!("IntersectionObserver" in window))return;
  var io=new IntersectionObserver(function(entries){
    var vis=entries[0].isIntersecting;
    bar.hidden=vis;
    bar.setAttribute("aria-hidden",vis?"true":"false");
    document.body.classList.toggle("hasbuybar",!vis);
  },{rootMargin:"0px 0px -20px 0px"});
  io.observe(real);
}

/* The wordmark types itself, then the caret keeps blinking.
 *
 * The word is in the markup already, so it is present with JS off and before
 * this runs; this clears it and puts it back a character at a time. Anyone who
 * has asked not to be animated gets it whole, immediately. */
function mountLanding(){
  /* the gate's outlined wordmark "types itself": 7 monospace letters, so each step
     uncovers 1/7 of the SVG's width. No JS / reduced motion: it simply shows. */
  var svg=document.querySelector(".lm-svg");
  if(!svg)return;
  var reduce=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if(reduce)return;
  var N=7,i=0,STEP=190;
  svg.style.clipPath="inset(0 100% 0 0)";
  (function type(){
    i++;svg.style.clipPath="inset(0 "+(100-i*100/N).toFixed(2)+"% 0 0)";
    if(i<N)setTimeout(type,STEP);else svg.style.clipPath="";
  })();
}

function mountGridCycle(){
  if(!window.matchMedia||!matchMedia("(hover:hover)").matches)return;
  if(matchMedia("(prefers-reduced-motion:reduce)").matches)return;
  document.querySelectorAll(".tile").forEach(function(tile){
    var imgs=Array.prototype.slice.call(tile.querySelectorAll(".shot img"));
    if(imgs.length<2)return;
    var i=0,timer=null;
    tile.addEventListener("mouseenter",function(){
      imgs.forEach(function(img){
        if(img.dataset.src){img.srcset=img.dataset.srcset||"";img.src=img.dataset.src;delete img.dataset.src;delete img.dataset.srcset;}
      });
      timer=setInterval(function(){
        imgs[i].classList.remove("current");
        i=(i+1)%imgs.length;
        imgs[i].classList.add("current");
      },700);
    });
    tile.addEventListener("mouseleave",function(){
      clearInterval(timer);
      imgs.forEach(function(img,idx){img.classList.toggle("current",idx===0);});
      i=0;
    });
  });
}

/* ── THE BEACON, LIVE — one client, several readouts ──────────────────────
 *
 * NIST emits one signed pulse every 60 seconds. The storefront showed a pulse
 * index from whichever batch was current — static text, often weeks old — so
 * the one genuinely uncopyable thing about this brand (an external, public,
 * independently checkable source) read as a claim rather than an instrument.
 *
 * This displays the SOURCE. It ships no generator and derives no design in the
 * browser, so brand law 2 is untouched — it is the same public endpoint
 * /pages/process links to.
 *
 * 2026-09-08: refactored from a single mount into a client. The home page's
 * readout and the process page's live steps both need the current pulse and
 * the countdown, and the process page also needs pulses BY INDEX to step back
 * through. One fetch, one clock, any number of subscribers.
 *
 * Failure is silence. Every readout is `hidden` in its markup and only revealed
 * once a pulse actually arrives: a readout stuck on an error, on the page whose
 * argument is "you can check us", is worse than no readout. */
var swBeacon=(function(){
  var API="https://beacon.nist.gov/beacon/2.0";
  var subs=[],last=null,timer=null,poll=null,cache={},started=false;
  /* 2026-10-08: NIST publishes the pulse stamped T about 30-35 s after T (measured: the
   * 17:04:00 pulse first answered at 17:04:34). Counting down to T + 60 s hit zero half a
   * minute early, then looped 5 s countdowns until the pulse appeared, and a failed refetch
   * froze it on "now". So the clock counts to T + period + lag, and lag is re-measured from
   * each pulse caught by polling; this also absorbs a visitor's clock being off. */
  var lag=35000;
  function get(url){
    return fetch(url,{mode:"cors"}).then(function(r){return r.ok?r.json():null;})
      .then(function(d){var p=d&&d.pulse;return(p&&p.pulseIndex&&p.timeStamp&&p.outputValue)?p:null;});
  }
  function emit(kind,p,left){subs.forEach(function(cb){try{cb(p,kind,left);}catch(e){}});}
  /* count down to when the next pulse should be published, from THIS pulse's
   * timestamp rather than from now, so a slow response does not skew the clock.
   * Once it's due, poll every 2 s (10 s after half a minute overdue, or while the
   * tab is hidden) until it lands. A failed fetch is just a missed poll. */
  function due(p){return new Date(p.timeStamp).getTime()+(Number(p.period)||60000)+lag;}
  function schedule(p){
    clearInterval(timer);clearTimeout(poll);
    var period=Number(p.period)||60000,at=due(p);
    function tick(){
      var ms=at-Date.now(),left=Math.max(0,Math.min(period/1000,Math.ceil(ms/1000)));
      emit("tick",last,left);
      if(ms<=0){clearInterval(timer);timer=null;
        poll=setTimeout(fetchLast,(ms<-30000||document.hidden)?10000:2000);}
    }
    timer=setInterval(tick,1000);tick();
  }
  function fetchLast(){
    var waiting=!!last;
    return get(API+"/pulse/last").catch(function(){return null;}).then(function(p){
      if(!p){if(last)schedule(last);return null;}
      cache[p.chainIndex+"/"+p.pulseIndex]=p;
      var fresh=!last||p.pulseIndex!==last.pulseIndex;
      /* a pulse caught by polling measures the lag, late by up to one poll; take 2 s
       * off so the next poll can start a little early and the lag can fall as well as rise */
      if(fresh&&waiting&&p.pulseIndex===last.pulseIndex+1){
        var seen=Date.now()-new Date(p.timeStamp).getTime();
        if(seen>=0&&seen<(Number(p.period)||60000))lag=Math.max(0,seen-2000);
      }
      last=p;
      if(fresh)emit("pulse",p);
      schedule(p);
      return p;
    });
  }
  /* a pulse by chain and index, memoised — stepping back and forth through the
   * strip must not refetch what it has already seen */
  function at(chain,index){
    var k=chain+"/"+index;
    if(cache[k])return Promise.resolve(cache[k]);
    return get(API+"/chain/"+chain+"/pulse/"+index).then(function(p){if(p)cache[k]=p;return p;});
  }
  function onPulse(cb){
    subs.push(cb);
    if(last)cb(last,"pulse");
    if(!started){started=true;if(window.fetch)fetchLast().catch(function(){/* silence */});}
  }
  return{onPulse:onPulse,at:at,last:function(){return last;}};
})();

/* paint one readout block (.bx pulse index, .bt timestamp, .bn countdown) */
function paintBeaconBlock(box,p,left){
  var q=function(c){return box.querySelector("."+c);};
  if(p){
    box.hidden=false;
    if(q("bx"))q("bx").textContent="#"+Number(p.pulseIndex).toLocaleString();
    if(q("bt"))q("bt").textContent=fmtUTC(p.timeStamp);
  }
  if(q("bn")&&typeof left==="number")q("bn").textContent=left<=0?"due":"in "+left+"s";
}

/* the home page readout. Its slot reserves the block's height so the grid does
 * not jump when the pulse lands; if none has landed after a few seconds the
 * slot lets go rather than holding a hole open. */
function mountBeacon(){
  var box=document.getElementById("beacon");
  var slot=document.getElementById("beaconslot");
  if(!box||!window.fetch){if(slot)slot.classList.add("empty");return;}
  var got=false;
  swBeacon.onPulse(function(p,kind,left){
    if(kind==="pulse")got=true;
    paintBeaconBlock(box,kind==="pulse"?p:null,kind==="tick"?left:undefined);
  });
  setTimeout(function(){if(!got&&slot)slot.classList.add("empty");},6000);
}

/* /collections/NN renders the shop page with that batch marked data-focus;
 * bring it into view, the way the #batch-NN anchor does for in-site links. */
function mountFocus(){
  /* a #batch-NN link to a retired batch opens its collapsed <details> (2026-09-27) */
  if(location.hash){
    var t=document.getElementById(location.hash.slice(1));
    /* open it and any folded <details> around it (the archive folds while a batch is open) */
    if(t){for(var d=t;d;d=d.parentElement){if(d.tagName==="DETAILS")d.open=true;}
      t.scrollIntoView({block:"start"});}
    return;
  }
  var f=document.querySelector("[data-focus]");
  if(f){for(var d=f;d;d=d.parentElement){if(d.tagName==="DETAILS")d.open=true;}
    f.scrollIntoView({block:"start"});}
}
/* The dither ground. Value noise seeded from the batch's seed, thresholded through a
 * 4×4 Bayer matrix into 1-bit cells, drawn in neutral grey at low alpha. ~15 fps, paused
 * while the tab is hidden, one still frame under prefers-reduced-motion. No network. */
function mountDither(){
  var cv=document.getElementById("swbg");if(!cv||!cv.getContext)return;
  var cx=cv.getContext("2d"),dpr=Math.min(window.devicePixelRatio||1,2);
  var seed=parseInt((cv.dataset.seed||"").slice(0,8),16)||1;
  var alpha=16,CELL=4; /* one strength on every page (was 16 home / 8 elsewhere) */
  var reduce=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches;
  var B4=[0,8,2,10,12,4,14,6,3,11,1,9,15,7,13,5];
  var off=document.createElement("canvas"),ox=off.getContext("2d"),W=0,H=0,last=0;
  function h(i,j,s){var n=(i*374761393+j*668265263+s*982451653)|0;n=Math.imul(n^(n>>>13),1274126177);return((n^(n>>>16))>>>0)/4294967295;}
  function vn(x,y,s){
    var xi=Math.floor(x),yi=Math.floor(y),xf=x-xi,yf=y-yi,u=xf*xf*(3-2*xf),v=yf*yf*(3-2*yf);
    var a=h(xi,yi,s),b=h(xi+1,yi,s),c=h(xi,yi+1,s),d=h(xi+1,yi+1,s);
    return a+(b-a)*u+(c-a)*v+(a-b-c+d)*u*v;
  }
  function size(){W=innerWidth;H=innerHeight;cv.width=W*dpr;cv.height=H*dpr;cx.setTransform(dpr,0,0,dpr,0,0);
    off.width=Math.ceil(W/CELL);off.height=Math.ceil(H/CELL);}
  function draw(t){
    var cw=off.width,ch=off.height,img=ox.createImageData(cw,ch),d=img.data,tt=t*0.00004;
    for(var y=0;y<ch;y++)for(var x=0;x<cw;x++){
      var v=vn(x/38+tt,y/38-tt*0.6,seed)*0.65+vn(x/11,y/11+tt*2,seed+7)*0.35;
      if(v*0.9>(B4[(y&3)*4+(x&3)]+0.5)/16+0.18){var o=(y*cw+x)*4;d[o]=226;d[o+1]=226;d[o+2]=228;d[o+3]=alpha;}
    }
    ox.putImageData(img,0,0);cx.clearRect(0,0,W,H);cx.imageSmoothingEnabled=false;
    cx.drawImage(off,0,0,cw*CELL,ch*CELL);
  }
  size();addEventListener("resize",function(){size();draw(performance.now());});
  /* always paint one frame up front: the loop below skips hidden tabs, and a page
     opened in a background tab would otherwise show nothing until it animates. */
  draw(0);
  if(reduce)return;
  (function loop(t){if(!document.hidden&&t-last>=66){last=t;draw(t);}requestAnimationFrame(loop);})(0);
}
function mountAll(){mountDither();mountFocus();mountLanding();paintCloseTimes();mountBeacon();mountShell();mountProduct();mountCandidate();mountGridCycle();mountStickyBuy();}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",mountAll);else mountAll();
window.ENTR0PY={batch:SW,beacon:swBeacon};
})();
